import React from 'react';
import ChestImage from '@shared/assets/images/v2/chest.svg';
import { View } from '@shared/components/View';
import { MBImage } from '@shared/components/image';
import { MBTextBody2, MBTextH4, MBTextSubtitle } from '@shared/components/typography';
import { grid } from '@shared/styles';
import { useIsDesktop } from '@shared/util/hooks';
import { i18n } from '@shared/util/i18n';

const IMAGE_ASPECT = 0.728; // 184x134.02

export function MBPermissionError() {
  // We only need a simple breakpoint
  const isDesktop = useIsDesktop();
  return (
    <View center flex>
      <MBImage
        source={ChestImage}
        style={{
          width: isDesktop ? grid(23) : grid(10), // taken directly from Figma
          height: isDesktop ? grid(23) * IMAGE_ASPECT : grid(10) * IMAGE_ASPECT,
          marginBottom: grid(5),
        }}
      />
      <View paddingBottom={1}>
        {isDesktop ? (
          <MBTextH4>{i18n('errors.noAccess.heading')}</MBTextH4>
        ) : (
          <MBTextSubtitle>{i18n('errors.noAccess.heading')}</MBTextSubtitle>
        )}
      </View>
      <View paddingBottom={4}>
        <MBTextBody2>{i18n('errors.noAccess.subHeading')}</MBTextBody2>
      </View>
    </View>
  );
}
